<template>
	<nav>
		<div class="col-auto pl-0 text-left">
			<template v-if="checkLayoutPreview">
				<i
					class="fas fa-chevron-left pointer"
					@click="closeLayoutPreview"
				></i>
			</template>
			<template v-else-if="checkStep">
				<i class="fas fa-chevron-left pointer" @click="backStep"></i>
			</template>
		</div>
		<div class="text-center layout-iframe-control-buttons">
			<template v-if="isThemeStep">
				<i
					class="fas fa-mobile-alt cursor-pointer"
					:class="ifremeModeActive === 'mobile' ? 'active' : ''"
					@click="changeIframeMode('mobile')"
				></i>
				<i
					class="fas fa-desktop cursor-pointer"
					:class="ifremeModeActive === 'desktop' ? 'active' : ''"
					@click="changeIframeMode('desktop')"
				></i>
			</template>
		</div>
		<div class="text-right">
			<template v-if="checkLayoutAndStep">
				<button class="btn btn-primario btn-large" @click="nextStep">
					Começar com esse
				</button>
			</template>
		</div>
	</nav>
</template>

<script>
	export default {
		data() {
			return {
				activeIframe: "desktop",
			};
		},
		props:{
			isThemeStep: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			backStep() {
				this.$emit('trigger-back-step');
			},
			closeLayoutPreview() {
				this.$store.dispatch("WIZARD_TOGGLE_LAYOUT_PREVIEW");
				this.$store.dispatch("WIZARD_CLEAR_LAYOUT_SELECTED");
			},
			changeIframeMode(mode) {
				this.$store.dispatch("WIZARD_CHANGE_IFRAME_MODE", [mode]);
			},
			nextStep() {
				this.$emit("nextStep");
			},
		},
		computed: {
			checkStep() {
				if (this.$store.state.wizard.step == 0) {
					return false;
				} else {
					return true;
				}
			},
			checkLayoutStep() {
				let step = this.$store.state.wizard.step;
				return (
					this.$store.state.wizard.components[step].step ==
					"StepWizardThemes"
				);
			},
			checkLayoutPreview() {
				return this.$store.state.wizard.layout.layoutPreview;
			},
			checkLayoutSelected() {
				return this.$store.state.wizard.dataSite.layout.id != null;
			},
			ifremeModeActive() {
				return this.$store.state.wizard.layout.iframeMode;
			},
			checkLayoutAndStep() {
				return this.isThemeStep && this.checkLayoutSelected;
			},
		},
	};
</script>

<style scoped>
	nav {
		height: 80px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		padding: 0 15px;
	}
	nav .layout-iframe-control-buttons {
		font-size: 1.3rem;
		color: #b2b2b2;
	}
	nav .layout-iframe-control-buttons i {
		padding: 0 10px;
	}
	nav .layout-iframe-control-buttons .active {
		color: var(--main-color);
	}
</style>


// WEBPACK FOOTER //
// src/components/molecules/WizardNavbar.vue